import { render, staticRenderFns } from "./ProfileMenu.vue?vue&type=template&id=5484ad37&scoped=true"
import script from "./ProfileMenu.vue?vue&type=script&lang=ts"
export * from "./ProfileMenu.vue?vue&type=script&lang=ts"
import style0 from "./ProfileMenu.vue?vue&type=style&index=0&id=5484ad37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5484ad37",
  null
  
)

export default component.exports